import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  scrollTo: PropTypes.func.isRequired,
};

const Hero = ({ scrollTo }) => (
  <>
    <div className="hero-wrap">
      <section className="hero">
        <button
        className="button hero-button"
        onClick={() => scrollTo('#competition')}
        type="button"
      >
        Osallistu ja voita AIRvive™
      </button>
      </section>
    </div>
    <section className="copy-section section">
      <p className="plaintext">
        <strong>REMINGTON® AIRvive™</strong>‑tuotesarja tuo uusia tuulia hiusten muotoiluun. Ionic Air ‑teknologia ja 
        lämmöstä aktivoituvat hoitavat mikroainesosat silottavat hiuksen pintaa. Ne lukitsevat kosteuden 
        hiuksen sisään niin kihartamisen, suoristamisen kuin kuivauksen aikana. Lopputuloksena on upea, 
        kestävä kampaus – joka kerta.
      </p>
      <p className="plaintext">
        Osallistu arvontaan kertomalla, mikä AIRvive™‑tuote olisi paras juuri sinulle.
    </p>
    <p className="plaintext">
        <strong>AIRvive ‑suoristusraudalla</strong> saat hiuksistasi 80 % tavanomaista sileämmät koko päivän ajaksi. <strong>2-in-1-ilmakiharrin</strong> 
         kuivaa ja silottaa kosteat hiukset, ja auttaa hiuksia säilyttämään luonnollisen kosteutensa jopa 24 
        tunnin ajan. <strong>AIRvive™-pyörivän kihartimen</strong> avulla luot helposti upeat kiharat, jotka pysyvät kauniina 
        ja sileinä koko päivän. <strong>AIRvive™ hiustenkuivaimen</strong> digitaalinen moottori, Ionic Air-teknologia ja 
        hellävarainen lämpötila takaavat nopean kuivauksen. Hiuksesi pysyvät sileinä ja pehmeinä. 
        Käyttömukavuutta lisää kuivaimen erittäin hiljainen ääni.
      </p>
      <p className="plaintext">
        Kerro millä SINÄ kesytät oman tyylisi ja voita oma AIRvive™‑tuotteesi!
      </p>
    </section>
  </>
);

Hero.propTypes = propTypes;

export default Hero;
